/*
  Vorelisse — ortam katmanı (ambient 3D)

  Tüm sayfaların arkasında duran, gerçek perspektifli bir yaprak alanı.
  Amaç dikkat çekmek DEĞİL: göz ilk bakışta "arka planda bir şey var" bile
  demez, yalnız sayfa düz bir kağıt gibi durmaz.

  NEDEN THREE.JS DEĞİL:
  three.min.js 600KB (gzip ~150KB). Zar zor görünen bir arka plan katmanı için
  bunu HER sayfaya yüklemek, "pahalı tema" iddiasının en kolay çürüdüğü yer
  olurdu. Bu dosya bağımlılıksız ham WebGL — sıkıştırılmış ~3KB, tek çizim
  çağrısı, 30fps'e kısılı. three.min.js yalnız 3D vitrin bölümünün olduğu
  sayfalarda yüklenmeye devam eder.

  Tasarım kuralları:
    - opaklık tema ayarındaki "yoğunluk" çarpanıyla ölçeklenir; üst sınır
      0.42'de sabit (krem zeminde metin okunurluğu için)
    - hareket çok yavaş; bir yaprak ekranı ~2 dakikada geçer
    - uzak kuşak daha bulanık dokuyla çizilir → sahte alan derinliği
    - imleç ve kaydırma yalnız paralaks üretir, tepki hissi vermez

  İçerik bölümlerinin kendi zemin rengi ve z-index: 1'i var; koyu bölümler
  (hero, ticker, footer) bu katmanı doğal olarak kapatır. Katman yalnız krem
  zeminli boşluklarda görünür — istenen de bu.
*/
(function () {
  'use strict';

  /* Kurulum kritik yolun DIŞINDA yapılır (requestIdleCallback). Doku üretimi
     ve shader derlemesi birkaç ms sürer; bu ms'ler LCP ile yarışmasın diye
     tarayıcı boşa çıkana kadar beklenir. Katmanın geç gelmesi görünmez —
     zemin rengi zaten sayfanınkiyle aynı. */
  function boot() {
    var canvas = document.querySelector('[data-ambient-3d]');
    if (!canvas) return;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var forced = document.documentElement.hasAttribute('data-force-motion');

    function bail() {
      canvas.parentNode && canvas.parentNode.removeChild(canvas);
      document.documentElement.classList.add('ambient-off');
    }

    if (reduced && !forced) return bail();

    // Zayıf cihazda WebGL açmanın bedeli, kazandırdığı hissin üstünde.
    if ((navigator.hardwareConcurrency || 4) <= 2 || (navigator.deviceMemory || 4) <= 2) {
      return bail();
    }

    /* failIfMajorPerformanceCaveat: tarayıcı yazılım rasterizerine (SwiftShader)
       düşecekse WebGL'i hiç açma — o durumda katman CPU'yu yer, karşılığında
       zar zor görünen bir şey verir. */
    var GL_OPTS = {
      alpha: true,
      antialias: false,
      depth: false,
      stencil: false,
      preserveDrawingBuffer: false,
      powerPreference: 'low-power',
      failIfMajorPerformanceCaveat: true
    };

    /* İki aşamalı deneme:
       1) failIfMajorPerformanceCaveat ile — donanım hızlandırma varsa geçer.
       2) Geçmezse bayraksız yeniden dene, ama YARI yaprakla ve 24fps ile.
          Katman hiç açılmayınca kullanıcı "yok" sanıyor; hiç göstermemektense
          hafifletilmiş sürümü göstermek daha doğru. */
    var lowPower = false;
    var gl;

    function tryContext(opts) {
      try {
        return canvas.getContext('webgl', opts) || canvas.getContext('experimental-webgl', opts);
      } catch (e) {
        return null;
      }
    }

    gl = tryContext(GL_OPTS);

    if (!gl) {
      var relaxed = {};
      for (var k in GL_OPTS) relaxed[k] = GL_OPTS[k];
      relaxed.failIfMajorPerformanceCaveat = false;
      gl = tryContext(relaxed);
      lowPower = !!gl;
    }

    if (!gl) return bail();

    var accent = hexRGB(canvas.getAttribute('data-accent') || '#B3122B');
    var gold = hexRGB(canvas.getAttribute('data-gold') || '#A8834F');
    var ink = hexRGB('#4A2C2A');

    /* Yoğunluk çarpanı (tema ayarı). 1 = eski, göze batmayan seviye.
       Üst sınır neden var: bu katman metnin ARKASINDA duruyor. Çarpan
       serbest bırakılsaydı 5 yazan biri gövde metnini okunmaz hale
       getirirdi; okunurluk pazarlık konusu değil. */
    var intensity = parseFloat(canvas.getAttribute('data-intensity'));
    if (!(intensity > 0)) intensity = 1;
    intensity = Math.min(intensity, 3);
    var OP_CEILING = 0.42;

    function hexRGB(h) {
      h = h.replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16);
      return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
    }

    /* --- Doku ----------------------------------------------------------------
       Yaprak dosyadan gelmez, canvas'ta çizilir: tek bir HTTP isteği bile
       eklemez. İki bulanıklık seviyesi üretilir — uzaktaki yaprak bulanık
       dokuyu kullanır, objektifin odak dışı bıraktığı şey gibi.              */

    function petalCanvas(blurPx) {
      var s = 256;
      var cv = document.createElement('canvas');
      cv.width = cv.height = s;
      var ctx = cv.getContext('2d');
      if (blurPx > 0) ctx.filter = 'blur(' + blurPx + 'px)';

      // Gül yaprağı silueti — iki bezier, uçta hafif kıvrım.
      ctx.beginPath();
      ctx.moveTo(s * 0.5, s * 0.09);
      ctx.bezierCurveTo(s * 0.93, s * 0.25, s * 0.9, s * 0.73, s * 0.5, s * 0.93);
      ctx.bezierCurveTo(s * 0.1, s * 0.73, s * 0.07, s * 0.25, s * 0.5, s * 0.09);
      ctx.closePath();

      // Kenara doğru sönen dolgu: kesik kenar yok, hep yumuşak geçiş.
      var g = ctx.createRadialGradient(s * 0.5, s * 0.46, s * 0.03, s * 0.5, s * 0.5, s * 0.52);
      g.addColorStop(0, 'rgba(255,255,255,1)');
      g.addColorStop(0.55, 'rgba(255,255,255,0.8)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fill();
      return cv;
    }

    function makeTexture(cv) {
      var t = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, cv);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.generateMipmap(gl.TEXTURE_2D);
      return t;
    }

    var texSharp = makeTexture(petalCanvas(0));
    var texSoft = makeTexture(petalCanvas(5));

    /* --- Program -------------------------------------------------------------- */

    function shader(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        return null;
      }
      return s;
    }

    var vs = shader(
      gl.VERTEX_SHADER,
      'attribute vec3 aPos;attribute vec2 aUV;attribute vec4 aCol;' +
        'uniform mat4 uVP;varying vec2 vUV;varying vec4 vCol;' +
        'void main(){vUV=aUV;vCol=aCol;gl_Position=uVP*vec4(aPos,1.0);}'
    );
    var fs = shader(
      gl.FRAGMENT_SHADER,
      'precision mediump float;uniform sampler2D uTex;varying vec2 vUV;varying vec4 vCol;' +
        'void main(){float a=texture2D(uTex,vUV).a;gl_FragColor=vec4(vCol.rgb,a*vCol.a);}'
    );
    if (!vs || !fs) return bail();

    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return bail();
    gl.useProgram(prog);

    var aPos = gl.getAttribLocation(prog, 'aPos');
    var aUV = gl.getAttribLocation(prog, 'aUV');
    var aCol = gl.getAttribLocation(prog, 'aCol');
    var uVP = gl.getUniformLocation(prog, 'uVP');
    var uTex = gl.getUniformLocation(prog, 'uTex');

    /* --- Yapraklar ------------------------------------------------------------
       Alan derinliği üç kuşak. Uzak kuşak kalabalık, sönük ve bulanık;
       yakın kuşak tek tük, biraz daha okunur.                                  */

    var SPREAD_X = 36,
      SPREAD_Y = 28;

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    /* Taban opaklıklar. Uzak kuşak daha soluk, yakın kuşak daha belirgin —
       alan derinliği hissini opaklık farkı taşıyor, bu yüzden çarpan hepsine
       aynı oranda uygulanıyor (fark korunuyor). */
    var BANDS = [
      { count: 15, z: [-30, -19], size: [3.4, 5.6], op: [0.10, 0.15], soft: 1 },
      { count: 11, z: [-18, -9], size: [2.1, 3.5], op: [0.13, 0.20], soft: 1 },
      { count: 7, z: [-8, -1], size: [1.1, 2.2], op: [0.17, 0.26], soft: 0 }
    ];

    // Yazılım rasterizerine düştüysek yükü yarıya indir.
    if (lowPower) {
      BANDS.forEach(function (b) {
        b.count = Math.max(3, Math.round(b.count / 2));
      });
    }

    var petals = [];
    BANDS.forEach(function (b) {
      for (var i = 0; i < b.count; i++) {
        /* Renk dağılımı. Kahverengi "mürekkep" tonu krem zeminde renk değil
           kir gibi okunuyordu; payı 1/3'ten 1/6'ya indirildi, boşalan pay
           markanın kırmızısına verildi. */
        var tone = Math.random();
        var col = tone > 0.62 ? gold : tone > 0.45 ? ink : accent;
        var size = rand(b.size[0], b.size[1]);
        petals.push({
          x: rand(-SPREAD_X / 2, SPREAD_X / 2),
          y: rand(-SPREAD_Y / 2, SPREAD_Y / 2),
          z: rand(b.z[0], b.z[1]),
          w: size,
          h: size * 1.35,
          rx: rand(0, 6.28),
          ry: rand(0, 6.28),
          rz: rand(0, 6.28),
          // Her yaprağın kendi ekseni ve temposu var — hepsi aynı hızda dönseydi
          // desen ele verirdi.
          sx: rand(-0.011, 0.011),
          sy: rand(-0.015, 0.015),
          sz: rand(-0.008, 0.008),
          rise: rand(0.006, 0.016),
          sway: rand(0.15, 0.5),
          phase: rand(0, 6.28),
          col: col,
          op: Math.min(OP_CEILING, rand(b.op[0], b.op[1]) * intensity),
          soft: b.soft
        });
      }
    });

    // Derinlik testi kapalı, harmanlama açık → arkadan öne çizilmeli.
    petals.sort(function (a, b) {
      return a.z - b.z;
    });

    var sharpList = petals.filter(function (p) {
      return !p.soft;
    });
    var softList = petals.filter(function (p) {
      return p.soft;
    });

    var FLOATS_PER_VERT = 9;
    var VERTS_PER_QUAD = 6;
    var buf = gl.createBuffer();
    var data = new Float32Array(petals.length * VERTS_PER_QUAD * FLOATS_PER_VERT);

    var UVS = [
      [0, 1],
      [1, 1],
      [1, 0],
      [0, 1],
      [1, 0],
      [0, 0]
    ];
    var CORNERS = [
      [-0.5, -0.5],
      [0.5, -0.5],
      [0.5, 0.5],
      [-0.5, -0.5],
      [0.5, 0.5],
      [-0.5, 0.5]
    ];

    // Köşeler CPU'da döndürülür: yaprak başına 4 döndürme, karede ~130 işlem.
    function writeQuads(list, offset) {
      var o = offset;
      for (var i = 0; i < list.length; i++) {
        var p = list[i];
        var cx = Math.cos(p.rx),
          sxr = Math.sin(p.rx);
        var cy = Math.cos(p.ry),
          syr = Math.sin(p.ry);
        var cz = Math.cos(p.rz),
          szr = Math.sin(p.rz);

        // R = Rz * Ry * Rx (yalnız gereken 6 bileşen hesaplanır)
        var m00 = cz * cy,
          m01 = cz * syr * sxr - szr * cx,
          m10 = szr * cy,
          m11 = szr * syr * sxr + cz * cx,
          m20 = -syr,
          m21 = cy * sxr;

        for (var v = 0; v < VERTS_PER_QUAD; v++) {
          var lx = CORNERS[v][0] * p.w;
          var ly = CORNERS[v][1] * p.h;
          data[o++] = p.x + m00 * lx + m01 * ly;
          data[o++] = p.y + m10 * lx + m11 * ly;
          data[o++] = p.z + m20 * lx + m21 * ly;
          data[o++] = UVS[v][0];
          data[o++] = UVS[v][1];
          data[o++] = p.col[0];
          data[o++] = p.col[1];
          data[o++] = p.col[2];
          data[o++] = p.op;
        }
      }
      return o;
    }

    /* --- Kamera --------------------------------------------------------------- */

    var vp = new Float32Array(16);

    function setVP(aspect, camX, camY, camZ) {
      var fov = 52 * (Math.PI / 180);
      var f = 1 / Math.tan(fov / 2);
      var near = 0.1,
        far = 120;
      // perspektif * translate(-cam)
      vp[0] = f / aspect;
      vp[1] = 0;
      vp[2] = 0;
      vp[3] = 0;
      vp[4] = 0;
      vp[5] = f;
      vp[6] = 0;
      vp[7] = 0;
      vp[8] = 0;
      vp[9] = 0;
      vp[10] = (far + near) / (near - far);
      vp[11] = -1;
      vp[12] = (-f / aspect) * camX;
      vp[13] = -f * camY;
      vp[14] = ((far + near) / (near - far)) * -camZ + (2 * far * near) / (near - far);
      vp[15] = camZ;
    }

    /* --- Girdi ---------------------------------------------------------------- */

    var pointerX = 0,
      pointerY = 0,
      px = 0,
      py = 0;

    window.addEventListener(
      'pointermove',
      function (e) {
        pointerX = (e.clientX / window.innerWidth - 0.5) * 2;
        pointerY = (e.clientY / window.innerHeight - 0.5) * 2;
      },
      { passive: true }
    );

    var scrollNow = window.scrollY || 0,
      scrollTo = scrollNow;
    window.addEventListener(
      'scroll',
      function () {
        scrollTo = window.scrollY || 0;
      },
      { passive: true }
    );

    var W = 0,
      H = 0;

    function resize() {
      W = window.innerWidth;
      H = window.innerHeight;
      var dpr = Math.min(window.devicePixelRatio || 1, 1.25);
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(resize, 160);
    });

    /* --- Döngü ---------------------------------------------------------------
       Sekme arkadayken tek kare bile çizilmez. 30fps'e kısılı: bu tempoda
       hareket zaten yavaş, 60fps'in görsel karşılığı yok ama pil ve GPU
       maliyeti iki katı.                                                      */

    var running = true,
      last = 0,
      prev = 0,
      elapsed = 0;
    var FRAME = lowPower ? 1000 / 24 : 1000 / 30;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        running = false;
      } else if (!running) {
        running = true;
        last = 0;
        prev = 0;
        requestAnimationFrame(loop);
      }
    });

    gl.disable(gl.DEPTH_TEST);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);

    var STRIDE = FLOATS_PER_VERT * 4;

    function loop(now) {
      if (!running) return;
      requestAnimationFrame(loop);
      /* Süre gerçek saatten değil, YALNIZ çizilen karelerden birikir. Sekme
         arkadayken duran bir sahne, öne gelince kaldığı yerden devam eder;
         duvar saati kullanılsaydı yapraklar bir anda zıplardı. */
      if (!prev) prev = now;
      elapsed += Math.min((now - prev) / 1000, 1 / 15);
      prev = now;

      if (now - last < FRAME) return;
      last = now;

      var t = elapsed;

      px += (pointerX - px) * 0.03;
      py += (pointerY - py) * 0.03;
      scrollNow += (scrollTo - scrollNow) * 0.08;

      for (var i = 0; i < petals.length; i++) {
        var p = petals[i];
        p.rx += p.sx;
        p.ry += p.sy;
        p.rz += p.sz;
        p.y += p.rise;
        // Yukarı süzülürken yana da salınır: düz çizgide çıkan yaprak olmaz.
        p.x += Math.sin(t * 0.12 + p.phase) * 0.004 * p.sway;
        if (p.y > SPREAD_Y / 2) {
          p.y = -SPREAD_Y / 2;
          p.x = rand(-SPREAD_X / 2, SPREAD_X / 2);
        }
      }

      var end = writeQuads(softList, 0);
      writeQuads(sharpList, end);

      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, data, gl.DYNAMIC_DRAW);
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 3, gl.FLOAT, false, STRIDE, 0);
      gl.enableVertexAttribArray(aUV);
      gl.vertexAttribPointer(aUV, 2, gl.FLOAT, false, STRIDE, 12);
      gl.enableVertexAttribArray(aCol);
      gl.vertexAttribPointer(aCol, 4, gl.FLOAT, false, STRIDE, 20);

      // Kaydırma paralaksı: sayfa bir hacmin içinden geçiyormuş gibi.
      var camY = -(scrollNow / Math.max(H, 1)) * 1.15 + -py * 0.42;
      setVP(W / Math.max(H, 1), px * 0.62, camY, 13);
      gl.uniformMatrix4fv(uVP, false, vp);

      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform1i(uTex, 0);
      gl.activeTexture(gl.TEXTURE0);

      gl.bindTexture(gl.TEXTURE_2D, texSoft);
      gl.drawArrays(gl.TRIANGLES, 0, softList.length * VERTS_PER_QUAD);

      gl.bindTexture(gl.TEXTURE_2D, texSharp);
      gl.drawArrays(gl.TRIANGLES, softList.length * VERTS_PER_QUAD, sharpList.length * VERTS_PER_QUAD);
    }

      resize();
      requestAnimationFrame(loop);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(boot, { timeout: 2000 });
  } else {
    setTimeout(boot, 240);
  }
})();
